import { createClient } from '@supabase/supabase-js';
import { useNavigate } from 'react-router-dom';

// Supabase client initialization
const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY
);

/**
 * Checks if a user is currently authenticated
 * @returns {Promise<boolean>} True if user is authenticated, false otherwise
 */
export const checkAuthentication = async () => {
  try {
    const { data: { session }, error } = await supabase.auth.getSession();
    
    if (error) {
      console.error('Authentication check error:', error.message);
      return false;
    }
    
    return !!session; // Return true if session exists, false otherwise
  } catch (error) {
    console.error('Error checking authentication:', error);
    return false;
  }
};

/**
 * Helper to safely navigate to help support if authenticated
 * or redirect to login if not
 */
export const navigateToHelpSupport = async (navigate) => {
  const isAuthenticated = await checkAuthentication();
  
  if (isAuthenticated) {
    navigate('/help-support');
  } else {
    // Store the intended destination for redirect after login
    sessionStorage.setItem('redirectAfterLogin', '/help-support');
    navigate('/signin');
  }
}; 